import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import {
  ResidentAppAsideLink,
  ResidentAppAsideSection,
  ResidentAppAsideText,
} from '@pandiafi/components'

import { DataLoader } from '../ContractChanges/ContractChangesDataLoader'
import { Form } from './Form'
import { TerminationDisallowedBanner } from './components/TerminationDisallowedBanner/TerminationDisallowedBanner'
import { ContractChangesBanner } from '../ContractChanges/components/ContractChangesBanner/ContractChangesBanner'
import { ContractChangesView } from '../ContractChanges/ContractChangesView/ContractChangesView'
import { resolveContractTerminationTerminology } from '../ContractChanges/utils/resolveContractTerminationTerminology'
import { ContractChangesViewState } from '../ContractChanges/types'
import { ContractChangesSection } from '../../../common/types'

import { useModuleConfig } from 'hooks/useModuleConfig/useModuleConfig'
import { useContractPaths } from 'hooks/useContractPaths/useContractPaths'

export const TerminateContract: FC = () => {
  const [view, setView] = React.useState<ContractChangesViewState>('form')
  const { t } = useTranslation(['terminateContract'])
  const { residentChangesPath } = useContractPaths()
  const { contractModification } = useModuleConfig()

  return (
    <DataLoader>
      {(data) => {
        const terminology = resolveContractTerminationTerminology(
          data.contract.contractType
        )

        return (
          <ContractChangesView
            title={t(terminology.viewTitle)}
            banner={
              contractModification ? (
                view === 'form' && (
                  <ContractChangesBanner
                    contract={data.contract}
                    tenants={data.tenants}
                    otherSection={ContractChangesSection.RESIDENT_CHANGES}
                  />
                )
              ) : (
                // Every step, so the reason stays visible after the form
                <TerminationDisallowedBanner
                  reason={data.contract.terminationDisallowedReason}
                  contractType={data.contract.contractType}
                />
              )
            }
            sidebarInfo={
              view === 'form' && (
                <ResidentAppAsideSection>
                  <ResidentAppAsideText>
                    {t(terminology.viewDescription)}
                  </ResidentAppAsideText>
                  {contractModification && (
                    <>
                      <ResidentAppAsideText>
                        {t('terminateContract:view.contractContinuesInfo')}
                      </ResidentAppAsideText>
                      <ResidentAppAsideText>
                        {t('terminateContract:view.residentChangesInfo')}
                      </ResidentAppAsideText>
                      <ResidentAppAsideLink href={residentChangesPath}>
                        {t('terminateContract:links.goToResidentChanges')}
                      </ResidentAppAsideLink>
                    </>
                  )}
                </ResidentAppAsideSection>
              )
            }
          >
            <Form {...data} view={view} setView={setView} />
          </ContractChangesView>
        )
      }}
    </DataLoader>
  )
}
